import Task, { TaskCommands } from './task';
import { Type } from '@warp-drive/core-types/symbols';
import { collectionCommand } from 'volta/utils/api';

import type { TForecastProjectStatus } from './types/forecast-projects';
import type {
  ICreateTaskCmd,
  IDeleteTaskCmd,
  IReopenTaskCmd,
  IResolveTaskCmd,
  IUpdateTaskCmd
} from './types/tasks';

export interface ForecastProjectTaskEntityPayload {
  fpHeaderId: string;
  revision?: string;
  revisionNumber: number;
  status: TForecastProjectStatus;
}

export default class ForecastProjectTask extends Task<
  Record<string, any>,
  ForecastProjectTaskEntityPayload
> {
  /**
   * Commands
   */

  static createTask = collectionCommand<
    ICreateTaskCmd,
    ForecastProjectTask,
    typeof ForecastProjectTask
  >(TaskCommands.CreateTask, {
    ajaxOptions: { queryParams: { include: 'createdBy,resolvedBy,assignees' } }
  });

  static updateTask = collectionCommand<
    IUpdateTaskCmd,
    ForecastProjectTask,
    typeof ForecastProjectTask
  >(TaskCommands.UpdateTask);

  static deleteTask = collectionCommand<IDeleteTaskCmd, void, typeof ForecastProjectTask>(
    TaskCommands.DeleteTask
  );

  static resolveTask = collectionCommand<
    IResolveTaskCmd,
    ForecastProjectTask,
    typeof ForecastProjectTask
  >(TaskCommands.ResolveTask);

  static reopenTask = collectionCommand<
    IReopenTaskCmd,
    ForecastProjectTask,
    typeof ForecastProjectTask
  >(TaskCommands.ReopenTask);
  // @ts-ignore
  [Type] = 'forecast-project-task' as const;
  static modelName = 'forecast-project-task';
}
